import Vue from 'vue';
import styles from "./paing.module.css";
export default Vue.extend({
  name: 'ComponentDemoPaging',
  props: {
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  render() {
    const h = arguments[0];
    const className = [];
    className.push(styles.dot);
    return h("div", {
      "class": className.join(' ')
    });
  }
});
//# sourceMappingURL=paging.js.map
